import * as React from 'react';
import { Oval } from 'react-loader-spinner';

import {
    TitleBadgeProps,
    TitleBadgeState,
    Finish,
    ColorStock,
    Properties,
    OptionName,
} from './TitleBadge.types';
import { CartButton } from '../CartButton';
import { StepsContainer } from '../StepsContainer';
import { StylesPanel } from '../StylesPanel';
import { ColoursPanel } from '../ColoursPanel';
import { Summary } from '../Summary';
import { Alert, AlertStatus } from '../Alert';
import { FinishSelection } from '../FinishSelection';
import { QuantitySelection } from '../QuantitySelection';
import { StepsPanel } from '../StepsPanel';
import { getStockOrder, findOption } from '../../utils/helpers';
import {
    ShopifyProductOption,
    SelectedOption,
    ShopifyProductVariant,
    OptionSelectEvent,
} from '../../utils/interfaces';

import './styles/TitleBadge.css';

class TitleBadge extends React.Component<TitleBadgeProps, TitleBadgeState> {
    private minQuantity: number;
    private customTitleBadge: boolean;
    private colourSelected: boolean;
    private finishSelected: boolean;

    constructor(props: TitleBadgeProps) {
        super(props);
        this.state = {
            productLoaded: false,
            product: {},
            selection: {},
            properties: {
                finish: Finish.Gold,
                [Properties.CustomTitle]: '',
            },
            colorStock: [],
        };
        this.colourSelected = false;
        this.finishSelected = false;
    }

    componentDidMount = async (): Promise<void> => {
        console.log('shineAssets', this.props.shineAssets);
        const response = await fetch(`/products/${this.props.handle}.js`);
        const product = await response.json();
        const urlParams = this.getParams(window.location.href);
        this.customTitleBadge = 
            product.handle.includes('custom-title-badge') || product.handle.includes('custom-tb-');
        this.minQuantity = 
            (product.tags && 
            product.tags.includes('New Title Badge')) || this.customTitleBadge ?
                10 : 1;
        
        // Set up initial Selected Options & Colour stock
        const styleOption = findOption(product.options, 'Style');
        const colourOption = findOption(product.options, 'Colour');
        const initialStyleSelection = this.selectInitialStyle(styleOption);
        const colourStock = this.getInitialColorStock(
            [initialStyleSelection],
            product.options,
            product.variants,
        );
        const initialColourSelection = this.selectInitialColor(colourOption, colourStock);

        let selectedOptions = urlParams.variant ?
            this.getVariantOptions(product.options, product.variants, urlParams.variant) :
            [initialStyleSelection, initialColourSelection];

        this.setState({
            product: product,
            selection: {
                options: selectedOptions as any,
                quantity: this.minQuantity,
                variantId: this.getSelectedVariantId(selectedOptions, product.variants),
                finish: Finish.Gold
            },
            properties: {
                ...this.state.properties,
                [Properties.CustomTitle]: urlParams.title ? urlParams.title : '',
            },
            colorStock: this.getInitialColorStock(selectedOptions, product.options, product.variants),
            productLoaded: true,
        });

        // @ts-ignore
        $('.image-title').textfill();
    }

    componentDidUpdate = (): void => {
        // @ts-ignore
        $('.image-title').textfill();
    }

    hasData = (): boolean => !!this.state.selection.options;

    getParams = (url: string): Record<string, string> => {
        const params: Record<string, string> = {};
        const parser = document.createElement('a');
        parser.href = url;
        const query = parser.search.substring(1);
        const vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    };

    getVariantOptions = (
        options: ShopifyProductOption[], 
        variants: ShopifyProductVariant[], 
        id: string
    ): SelectedOption[] => {
        const selectedOptions: SelectedOption[] = [];
        const selected = variants.filter((variant: ShopifyProductVariant) => {
            return variant.id + '' === id;
        });

        selected[0].options.forEach((selectedOption: string) => {
            const match = options.filter((option: ShopifyProductOption)=> {
                return option.values.includes(selectedOption);
            });
            const optionName = match.length > 0 ? match[0].name : '';
            selectedOptions.push({
                name: optionName,
                value: selectedOption
            })
        });
        return selectedOptions;
    }

    getVariant = (
        style: string,
        color: string,
        variants?: ShopifyProductVariant[]
    ): ShopifyProductVariant | null => {
        const productVariants: ShopifyProductVariant[] | null = variants ? variants : this.state.product.variants;
        return productVariants ? productVariants.filter((variant: ShopifyProductVariant) => {
            return variant.option1 === style && variant.option2 === color;
        })[0] : null;
    }

    getSelectedVariant = (
        selectedOptions?: SelectedOption[],
        variants?: ShopifyProductVariant[]
    ): ShopifyProductVariant | null => {
        const options = selectedOptions ? selectedOptions : this.state.selection.options;
        if(this.hasData() || (selectedOptions && selectedOptions.length > 0)) {
            const selectedStyle = options.filter(
                option => option.name === 'Style'
            );
            const selectedColor = options.filter(
                option => option.name === 'Colour'
            );
            const variant = this.getVariant(
                selectedStyle[0].value as string,
                selectedColor[0].value as string,
                variants,
            );
            return variant;
        }
        return null;
    }

    getSelectedVariantId = (
        selectedOptions?: SelectedOption[],
        variants?: ShopifyProductVariant[]
    ): number | null => {
        const selectedVariant = this.getSelectedVariant(
            selectedOptions, variants
        );
        return selectedVariant.id;
    }

    getSelectedOptionValueByName = (optionName: string): string => {
        if(this.state && this.state.selection && this.state.selection.options)
            return this.state.selection.options.filter(
                item => item.name === optionName
            )[0].value;
        return null;
    }

    getInitialColorStock = (
        selectedOptions: SelectedOption[],
        options: ShopifyProductOption[],
        variants: ShopifyProductVariant[],
    ): ColorStock[] => {
        const selectedStyle = selectedOptions.filter(
            item => item.name === 'Style'
        )[0].value;
        const colors = options.filter(
            item => item.name === 'Colour'
        )[0];
        return this.getColorStock(selectedStyle as string, colors, variants);
    }

    getUpdatedColorStock = (): ColorStock[] => {
        if(this.hasData()) {
            const selectedStyle = this.getSelectedOptionValueByName('Style');
            const colors = this.state.product.options.filter(
                item => item.name === 'Colour'
            )[0];
            const colourStock = this.getColorStock(selectedStyle, colors);
            return colourStock;
        }
        return [];
    }

    getColorStock = (
        selectedStyle: string,
        colors: ShopifyProductOption,
        variants?: ShopifyProductVariant[],
    ): ColorStock[] => {
        const colorStock: ColorStock[] = [];
        colors.values.forEach(color => {
            const variant = this.getVariant(selectedStyle, color, variants);
            if (variant) {
                const stock = color === "Custom Colour" ? "0" : variant.inventory_quantity + '';
                colorStock.push(
                    { 
                        color: color,
                        stock: parseFloat(stock) < 0 ? "0" : stock,
                    }
                );
            }
        });
        // }
        return colorStock;
    }

    selectInitialStyle = (styles: ShopifyProductOption) => ({
        name: styles.name,
        value: styles.values[0],
    });

    selectInitialColor = (colours: ShopifyProductOption, stock: ColorStock[]) => {
        const stockOrder = getStockOrder(stock);
        return ({
            name: colours.name,
            value: stockOrder[0],
        });
    };

    onSelectHandler = (e: OptionSelectEvent): void => {
        // todo: this isn't updating as I would expect.
        let _state = this.state;

        if (e.name === OptionName.Colour) {
            this.colourSelected = true;
        } else if (!this.colourSelected) {
            const colors = this.state.product.options.filter(
                item => item.name === 'Colour'
            )[0];
            const colourStock = this.getColorStock(e.value, colors);
        }

        const isCustomColour = e.value === 'Custom Colour';
        const isGoldColor = e.value.includes('Gold');
        const isSilverColor = e.value.includes('Silver');
        const isBronzeColor = isCustomColour && e.colour?.includes('Bronze')
        const isBronzeFinish = _state.properties.finish === Finish.Bronze;


        _state.selection.options.forEach(option => {
            if(option.name === e.name) {
                // If it's a custom colour we need to ensure we're passing the actual colour through to the badge image.
                option.value = e.value;
            }
            // If colour has not been selected then we can reset the colour to the one with most stock
            if (
                option.name === OptionName.Colour &&
                e.name === OptionName.Style && 
                !this.colourSelected
            ) {
                const colors = this.state.product.options.filter(
                    item => item.name === 'Colour'
                )[0];
                const colourStock = this.getColorStock(e.value, colors);
                const stockOrder = getStockOrder(colourStock);
                option.value = stockOrder[0];
            }
        });

        _state.selection.variantId = this.getSelectedVariantId(_state.selection.options);
        _state.properties.customColour = isCustomColour ? e.colour : null;
        _state.colorStock.splice(0,_state.colorStock.length);
        _state.colorStock.push(...this.getUpdatedColorStock());

        if(!isBronzeColor && isBronzeFinish) _state.properties.finish = Finish.Gold;
        if(isGoldColor) _state.properties.finish = Finish.Gold;
        if(isSilverColor) _state.properties.finish = Finish.Silver;
        if(isBronzeColor) _state.properties.finish = Finish.Bronze;
        if(!isGoldColor && !isSilverColor && !isGoldColor && !this.finishSelected) {
            _state.properties.finish = Finish.Gold;
        }
        this.setState(_state);
    }

    onFinishChangeHandler = (finish: string): void => {
        let _state = this.state;
        this.finishSelected = true;
        _state.properties.finish = finish;
        this.setState(_state);
    };
    
    onQuantityChangeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const val = parseInt(e.target.value);
        const formattedVal = isNaN(val) ? '' : val;
        let _state = this.state;
        _state.selection.quantity = formattedVal;
        this.setState(_state);
    };

    onQuantityBlurHandler = (e: KeyboardEvent) => {
        const val = parseInt((e.target as HTMLInputElement).value);
        if(val < this.minQuantity || isNaN(val)) {
            alert(`Minimum order quantity for this item is ${this.minQuantity}`);
            let _state = this.state;
            _state.selection.quantity = this.minQuantity;
            this.setState(_state);
        }
    };

    render(): JSX.Element {
        const {
            product, 
            selection,
            properties,
            colorStock,
        } = this.state;
    
        if (!this.state.productLoaded) {
            return (
                <div className="title-badge">
                    <div className="title-badge__loading">
                        <Oval
                            color="#40549c"
                            secondaryColor="#40549c"
                            height={100}
                            width={100}
                            visible
                        />
                    </div>
                </div>
            );
        }

        const hasCustomTitle = properties[Properties.CustomTitle] && properties[Properties.CustomTitle] !== '';
        if (this.customTitleBadge && !hasCustomTitle) {
            return (
                <Alert status={AlertStatus.Warning}>
                    Please specify a title. Return to <a href="/collections/title-badges" title="Title Badges page">Title Badges page</a> and enter a title.
                </Alert>
            );
        }
        
        let step = 1;
        const { title, options } = product;    
        const { finish } = properties;
        const styleOptions = options?.find(option => option.name === OptionName.Style);
        const colourOptions = options?.find(option => option.name === OptionName.Colour);
        const selectedStyleValue = this.getSelectedOptionValueByName(styleOptions?.name);
        const selectedColourValue = this.getSelectedOptionValueByName(colourOptions?.name);
        const badgeTitle = this.customTitleBadge ? properties[Properties.CustomTitle] : title;
        const quantity =  selection.quantity ? selection.quantity : this.minQuantity;
        const selectedColor = this.getSelectedOptionValueByName('Colour');
        const isGoldColor = selectedColor?.includes('Gold');
        const isSilverColor = selectedColor?.includes('Silver');
        const isBronzeColor = selectedColor?.includes('Custom Colour') && properties.customColour?.includes('Bronze');
    
        return (
            <>
                <div className="title-badge-banner">
                    <h1>{badgeTitle && badgeTitle.length > 0 ? badgeTitle : title}</h1>
                </div>
                <div className="title-badge">
                    <div style={{ flex: 1, width: '100%' }}>
                        <StepsContainer
                            className="col"
                        >
                            <StylesPanel
                                value={selectedStyleValue}
                                title={styleOptions?.name}
                                step={step++}
                                key={`OptionPanel${step}`}
                                name={styleOptions?.name}
                                option={styleOptions}
                                onSelect={this.onSelectHandler}
                            />
                            <FinishSelection 
                                step={step++}
                                isSilverColor={isSilverColor}
                                isBronzeColor={isBronzeColor}
                                isGoldColor={isGoldColor}
                                onChange={this.onFinishChangeHandler}
                                finish={finish as Finish}
                            />
                            <ColoursPanel
                                value={selectedColourValue}
                                title={colourOptions?.name}
                                step={step++}
                                stock={colorStock}
                                finish={properties.finish as Finish}
                                key={`OptionPanel${step}`}
                                name={colourOptions?.name}
                                option={colourOptions}
                                onSelect={this.onSelectHandler}
                            />
                            <QuantitySelection
                                step={step++}
                                quantity={selection.quantity}
                                minQuantity={this.minQuantity}
                                selectedVariant={this.getSelectedVariant()}
                                onBlur={this.onQuantityBlurHandler}
                                onChange={this.onQuantityChangeHandler}
                            />
                            <StepsPanel
                                step={step++}
                                title=""
                            >
                                <CartButton
                                    productId={selection && selection.variantId}
                                    quantity={quantity}
                                    properties={{
                                        ...properties,
                                    }}
                                />
                            </StepsPanel>
                        </StepsContainer>
                        
                    </div>
                    <Summary 
                        className="col"
                        title={badgeTitle}
                        shineAssets={this.props.shineAssets}
                        selectedOptions={
                            selection.options ? selection.options : null
                        }
                        variants={product.variants ? product.variants : []}
                        quantity={quantity}
                        properties={properties}
                    />
                </div>
            </>
        );
    }
};

export { TitleBadge };